import { defineComponent as _defineComponent } from 'vue'
import type { ContentReference, ContentCollection } from '@ilteducation/content-collections-types';
import { onBeforeMount, ref, toRefs } from 'vue';
import type { Content } from '@ilteducation/content-registry-types';
import { useRoute } from 'vue-router/composables';
import store from '@/store';
import useCollectionUtils from '@/resources/collections/use-collection-utils';
import { getOne } from '@/data-provider/contentCollections';
import eventBus from '@/foundations/services/eventBus';

type Props = {
  id: string;
  title: string;
  realm?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'Show',
  props: {
    id: null,
    title: null,
    realm: null
  },
  setup(__props: any) {

const props = __props as {
  id: string;
  title: string;
  realm?: string;
}


const { id: itemId, title } = toRefs(props);

const route = useRoute();
const { contentTypes, getTitleInRealmLanguage } = useCollectionUtils();

const item = ref<ContentCollection | undefined>();
const contents = ref<Content[]>([]);

const getRouteFromName = (name: string) => {
  const t = contentTypes.find((ct) => ct.name === name);
  return t?.route;
};

const getCoverUrl = (content: Content) => {
  if (!content) {
    return '';
  }
  if (content.type === 'BookV1') {
    const cfUrl = process.env.VUE_APP_COVERS_DOMAIN;
    return `https://${cfUrl}/bookCovers/${content.id}/cover.png?width=170`;
  }
  if (content.type === 'VideoV1') {
    const domain = process.env.VUE_APP_COVERS_DOMAIN;
    return `https://${domain}/public/videos/${content.id}/${content.previewImage?.[item.value.realm]?.fileName}`;
  }
  return '';
};

onBeforeMount(async () => {
  const { realm } = route.query;
  try {
    item.value = await getOne(props.realm ?? realm, itemId?.value);

    // Fetch the content objects
    if (item.value.contents.type !== 'ContentsByReferences') {
      return;
    }
    item.value.contents.references.forEach((contentReference: ContentReference) => {
      const route = getRouteFromName(contentReference.type);
      store.dispatch(`${route}/getOne`, { id: contentReference.id }).then((response) => {
        if (response) {
          contents.value = [...contents.value, response.data];
        }
      });
    });
  } catch (e) {
    console.error(e);
    eventBus.$emit('snackbarV2.open', { text: e, color: 'error' });
  }
});

return { __sfc: true,props, itemId, title, route, contentTypes, getTitleInRealmLanguage, item, contents, getRouteFromName, getCoverUrl }
}

})